/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signin_BackInputs */

const en_signin_back = /** @type {(inputs: Signin_BackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Back to home`)
};

const id_signin_back = /** @type {(inputs: Signin_BackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kembali ke beranda`)
};

/**
* | output |
* | --- |
* | "Back to home" |
*
* @param {Signin_BackInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const signin_back = /** @type {((inputs?: Signin_BackInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signin_BackInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_signin_back(inputs)
	return en_signin_back(inputs)
});